import "/__w/1/s/BotFramework-WebChat/packages/component/src/Attachment/Text/private/ActivityButton.module_built.css";
const classes = {"activity-button":"wMObAfW_activity-button","activity-button__icon":"wMObAfW_activity-button__icon"}
export default classes

const _activity_button0 = classes["activity-button"]
export { _activity_button0 as "activity-button" }

const _activity_button__icon0 = classes["activity-button__icon"]
export { _activity_button__icon0 as "activity-button__icon" }
